export default {
  save: 'Enregistrer',
  delete: 'Supprimer',
  'save-as': 'Enregistrer sous',
  update: 'Modifier',
  cancel: 'Annuler',
  previous: 'Précédent',
  next: 'Suivant',
  about: 'A propos',
  advanced: 'Avancé',
  link: 'Lien',
  thumbnail: 'Miniature',
  badges: 'Badges',
  avatar: 'Avatar',

  name: 'Nom',
  resume: 'Description',
  description: 'Description',
  period: 'Période',
  events: 'Evénements',
  score: 'Score',
  success: 'Phrase de succès',

  activities: 'Fil d\'activités',
  gamifications: 'Gamifications',
  messages: 'Messages',
  friends: 'Amis',

  timeframe: {
    noperiod: 'Aucune période',
    morning: 'le matin',
    midday: 'le midi',
    afternoon: 'l\'après-midi',
    evening: 'le soir',
    day: 'la journée',
    night: 'la nuit',
    monday: 'le lundi',
    tuesday: 'le mardi',
    wednesday: 'le mercredi',
    thursday: 'le jeudi',
    friday: 'le vendredi',
    saturday: 'le samedi',
    sunday: 'le dimanche',
    weekend: 'le week-end'
  },

  sentencestart: 'Phrase de lancement',
  sentencedead: 'Phrase de fin réussi',
  sentencesurvive: 'Phrase de fin échoué'
}



// WEBPACK FOOTER //
// ./src/translations/fr/common.js